var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#212529",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00049 9.99902C4.90049 9.99902 4.00049 10.899 4.00049 11.999C4.00049 13.099 4.90049 13.999 6.00049 13.999C7.10049 13.999 8.00049 13.099 8.00049 11.999C8.00049 10.899 7.10049 9.99902 6.00049 9.99902ZM18.0005 9.99902C16.9005 9.99902 16.0005 10.899 16.0005 11.999C16.0005 13.099 16.9005 13.999 18.0005 13.999C19.1005 13.999 20.0005 13.099 20.0005 11.999C20.0005 10.899 19.1005 9.99902 18.0005 9.99902ZM12.0005 9.99902C10.9005 9.99902 10.0005 10.899 10.0005 11.999C10.0005 13.099 10.9005 13.999 12.0005 13.999C13.1005 13.999 14.0005 13.099 14.0005 11.999C14.0005 10.899 13.1005 9.99902 12.0005 9.99902Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.a998239b.svg";
export { ForwardRef as ReactComponent };